export const MAX_CARTESIAN_CHART_CATEGORIES = 20;
export const MAX_CARTESIAN_CHART_SERIES = 4;
export const MAX_CARTESIAN_CHART_CELLS = 60;
export const MAX_PIE_CHART_SLICES = 10;
// NOTE: NSAI-5661 — user-requested colours, one per series or slice at most.
export const MAX_CHART_COLORS = 10;

// NOTE: NSAI-4673 — a dedicated categorical ramp, one entry per allowed pie
// slice. It replaces the previous list of seven *semantic* tokens
// (chart-primary / chart-destructive / chart-success / chart-primary-dark /
// chart-warning / chart-accent / chart-muted), which borrowed UI surface roles
// to colour data. That failed in two ways: `accent` and `muted` are near-white
// surface fills, and `warning` is a pale yellow — measured against the light
// chart card they sit at 1.14:1, 1.09:1 and 1.25:1, i.e. slices five, six and
// seven were invisible, and in dark theme `accent` and `muted` are literally
// the same value. A category is not a status, so the ramp no longer aliases
// status colours; the defaults below are picked for the job and every one of
// them clears 3:1 against the card in both themes with a pairwise CIE76 dE of
// at least 25. `chart-series-1` still resolves to the org's primary on web, so
// a branded chart still leads with the brand colour.
export const CHART_PALETTE_KEYS = [
  "chart-series-1",
  "chart-series-2",
  "chart-series-3",
  "chart-series-4",
  "chart-series-5",
  "chart-series-6",
  "chart-series-7",
  "chart-series-8",
  "chart-series-9",
  "chart-series-10",
] as const;

// NOTE: Reached only once a chart asks for more series than the ramp holds, and
// nothing in the app does today: a pie is capped at MAX_PIE_CHART_SLICES, which
// is the ramp's own length, and every Cartesian caller sits at or below
// MAX_CARTESIAN_CHART_SERIES. The branch is kept — and covered by unit tests
// rather than by a screen — because it is where a raised cap would land first,
// and it is the one place the RN-unparseable slash syntax could come back. The
// wrapped colour is dimmed so a repeat reads as a repeat.
export const OVERFLOW_OPACITY = 0.7;
